import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResourceService } from './resource.service';
import { CustomGhg } from '@model';

@Injectable()
export class CustomGhgService {
  constructor(private customGhgResourceService: ResourceService<CustomGhg>) {}

  getCustomGhg$(scenarioId: string): Observable<CustomGhg[]> {
    return this.customGhgResourceService.getList(`scenarios/${scenarioId}/ghg`);
  }

  deleteCustomGhg$(id: string): Observable<CustomGhg> {
    return this.customGhgResourceService.delete(`ghg`, id);
  }
}
